import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {isEmpty as _isEmpty} from 'lodash';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import useQueryCustom from '@utils/hooks/useQueryCustom';
import {GetFiltersDataForSrtOriginEntryPoints} from '@graphql/srtOriginEntryPoints/query';
import {showErrorModal} from '@utils/modal';
import {getLink} from '@appComponents/Link';
import {routes} from '@constants/routes';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {ContentCategoriesFilter} from '@utils/commonFilters/ContentCategoriesFilter';
import {TournamentsFilter} from '@utils/commonFilters/TournamentsFilter';

const SrtOriginEntryPointsFilters = ({filters, loading: isDataLoading, restoreFilterValues}) => {
    const {
        data: {tournaments = [], contentCategories = []} = {},
        loading: areFiltersLoading = true,
        error: dataError = {},
    } = useQueryCustom({
        query: GetFiltersDataForSrtOriginEntryPoints,
        options:  {
            fetchPolicy: 'no-cache',
        }}
    );

    const loading = (areFiltersLoading || isDataLoading) && _isEmpty(dataError);

    useEffect(() => {
        if (!_isEmpty(dataError)) {
            showErrorModal({
                header: 'Error with filters',
                redirectLink: getLink(`${routes}.srtOriginEntryPoints.index`),
                text: 'There was an error while fetching the filters data.',
                errorButtonIcon: 'arrow circle left',
                errorButtonText: 'Back to list',
            });
        }
    }, [dataError]);

    return (
        <div className='filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={filters.srtOriginEntryPoints}
                restoreFilterValues={restoreFilterValues}
            />
            <TournamentsFilter
                tournaments={tournaments}
                loading={loading}
                filters={filters.srtOriginEntryPoints}
                restoreFilterValues={restoreFilterValues}
            />
            <ContentCategoriesFilter
                contentCategories={contentCategories}
                loading={loading}
                filters={filters}
                restoreFilterValues={restoreFilterValues}
                filterName='srtOriginEntryPoints'
            />
        </div>
    );
};

SrtOriginEntryPointsFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(SrtOriginEntryPointsFilters, {name: 'srtOriginEntryPoints'});

